import type { ValueOf } from '../types';

export const AspectRatio = {
  '16:9': '16:9',
  '3:2': '3:2',
  '1:1': '1:1',
  '9:16': '9:16',
} as const;

export type AspectRatio = ValueOf<typeof AspectRatio>;
